import React from 'react';
import { format, parseISO } from 'date-fns';

const TimeslotCell = (props) => {

    const formatTimeslot = (row) => {
        let start = parseISO(row.start);
        let end = parseISO(row.end);
        return `${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`;
    }

    return (
        <span style={{
            textDecoration: (props.row.hasOwnProperty('archived_at') && props.row.archived_at !== null)
                ? 'line-through' : 'inherit'
        }}>
            { formatTimeslot(props.row) }
        </span>
    );
}

export default TimeslotCell;
